module.exports = __webpack_public_path__ + "static/img/8.80fc823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/8.png
// module id = qK96
// module chunks = 0